<template>
  <div>
    <el-button @click="dialogVisibles = true">基本设置</el-button>
    <el-dialog
      :visible.sync="dialogVisibles"
      title="抢购基本设置"
      width="1000px"
      @close="closeDialog"
      @open="openDialog"
    >
      <el-form
        :model="baseForm"
        ref="baseForm"
        :rules="rules"
        label-width="300px"
      >
        <el-form-item label="每个用户基本抢购额度" prop="baseAmount">
          <el-input-number v-model="baseForm.baseAmount"></el-input-number>
        </el-form-item>
        <el-form-item label="邀请额度" prop="singleInviteAmount">
          <el-input-number
            v-model="baseForm.singleInviteAmount"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="拥有1USDT增加的额度" prop="ownUsdtAmount">
          <el-input-number v-model="baseForm.ownUsdtAmount"></el-input-number>
        </el-form-item>
        <el-form-item label="拥有1FBS增加的额度" prop="ownFbsAmount">
          <el-input-number v-model="baseForm.ownFbsAmount"></el-input-number>
        </el-form-item>
        <el-form-item
          label="平台奖励推荐人FBS的百分比（整型0-100）"
          prop="inviteRewardProportion"
        >
          <el-input-number
            v-model="baseForm.inviteRewardProportion"
            :step="1"
            :step-strictly="true"
            :min="0"
            :max="100"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="单次最大抢购量" prop="singleMaxAmount">
          <el-input-number v-model="baseForm.singleMaxAmount"></el-input-number>
        </el-form-item>
        <el-form-item label="平台抢购开关" prop="amdinShoppingSwitch">
          <el-switch
            v-model="baseForm.amdinShoppingSwitch"
            active-color="#13ce66"
          >
          </el-switch>
        </el-form-item>
        <el-form-item
          label="首次抢购日期（根据日期显示抢购为第几天）"
          prop="initDate"
        >
          <el-date-picker
            v-model="baseForm.initDate"
            type="date"
            value-format="timestamp"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="平台单次抢购额度范围"
          prop="adminShoppingSingleAmountRange"
        >
          <el-col :span="7">
            <el-form-item prop="adminShoppingSingleMinAmount">
              <el-input-number
                v-model="baseForm.adminShoppingSingleMinAmount"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col class="text-center" :span="2">~</el-col>
          <el-col :span="7">
            <el-form-item prop="adminShoppingSingleMaxAmount">
              <el-input-number
                v-model="baseForm.adminShoppingSingleMaxAmount"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibles = false">取消</el-button>
        <el-button type="primary" @click="handleSave('baseForm')"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Editor from 'components/editor';

export default {
  name: 'CreateContent',
  data() {
    return {
      dialogVisibles: false,
      baseForm: {
        baseAmount: '',
        singleInviteAmount: '',
        ownUsdtAmount: '',
        ownFbsAmount: '',
        inviteRewardProportion: '',
        singleMaxAmount: '',
        amdinShoppingSwitch: false,
        initDate: '',
        adminShoppingSingleMinAmount: '',
        adminShoppingSingleMaxAmount: ''
      },
      rules: {
        adminShoppingSingleMinAmount: [
          {
            validator: (rule, value, callback) => {
              if (this.baseForm.adminShoppingSingleMaxAmount) {
                if (!value) {
                  callback(new Error('如果设置了最大值,最小值不能为空'));
                }
                callback();
              } else {
                callback();
              }
            }
          }
        ],
        adminShoppingSingleMaxAmount: [
          {
            validator: (rule, value, callback) => {
              if (this.baseForm.adminShoppingSingleMinAmount) {
                if (!value) {
                  callback(new Error('如果设置了最小值,最大值不能为空'));
                }
                callback();
              } else {
                callback();
              }
            }
          }
        ]
      }
    };
  },
  components: {
    Editor
  },
  computed: {
    ...mapState('contentSetting', ['languageList'])
  },
  methods: {
    ...mapActions('foundationProject', [
      'setBaseAmount',
      'getBaseAmount',
      'freshData'
    ]),
    closeDialog() {
      this.$refs['baseForm'].resetFields();
    },
    openDialog() {
      this.getBaseAmount().then(res => {
        this.baseForm = res.data;
      });
    },
    handleSave(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.setBaseAmount(this.baseForm).then(() => {
            this.$message.success('成功！');
            this.dialogVisibles = false;
          });
        }
      });
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
.editor {
  height: 500px;
}
</style>
